module.exports = __webpack_public_path__ + "media/payment_networks/cashapp-0b4f998f.png";